/** Role names and the role-management UI, shared by projects and dataspaces. */

export default {
	roles: {
		tab: "Rollen",
		names: {
			viewer: "Betrachter",
			editor: "Bearbeiter",
			admin: "Admin",
			member: "Mitglied",
			owner: "Eigentümer",
		},
		manage: {
			title: {
				project: "Projektrollen",
				dataspace: "Dataspace-Rollen",
			},
			createRole: "Rolle erstellen",
			editRole: "Rolle bearbeiten",
			duplicateRole: "Duplizieren",
			duplicateName: "Kopie von {name}",
			roleName: "Rollenname",
			deleteConfirm: "Rolle „{name}“ löschen?",
			permission: "Berechtigung",
			granted: "Erlaubt",
			notGranted: "Nicht erlaubt",
			systemRole: "Eingebaut",
			deleteNote:
				"Mitglieder mit dieser Rolle verlieren die damit verbundenen Berechtigungen. Das lässt sich nicht rückgängig machen.",
			saved: "Rolle {name} gespeichert.",
			deleted: "Rolle {name} gelöscht.",
			processCount: "{n} Prozess | {n} Prozesse",
			noProcesses: "Keine passenden Prozesse.",
			processPicker: "Prozesse auswählen…",
			sections: {
				management: "Verwaltung",
				project: "Projekt",
				axioms: "Axiome",
				terminology: "Terminologie",
				thumbnails: "Vorschaubilder",
				metadata: "Metadaten",
				git: "Git",
				build: "Build",
				releases: "Releases",
				dependencies: "Abhängigkeiten",
				utilities: "Utilities",
				entryPage: "Startseite",
				codenames: "Code-Namen",
				dataspace: "Dataspace",
				env: "Umgebung",
				telephony: "Telefonie",
			},
			ops: {
				read: "Lesen",
				update: "Bearbeiten",
				write: "Schreiben",
				execute: "Ausführen",
				release: "Releases erstellen",
				members: "Mitglieder verwalten",
				invitations: "Einladungen verwalten",
				roles: "Rollen verwalten",
				env: "Umgebungsvariablen verwalten",
				telephony: "Telefonie verwalten",
				processes: {
					view: "Prozesse ansehen",
					takePart: "In Prozessen mitarbeiten",
					start: "Prozesse starten",
					manage: "Prozesse verwalten",
					alias: "Prozesse mit einem Alias benennen",
					access: "Prozesse für einzelne Personen freigeben",
				},
			},
			/** Die Prozessrechte einer Dataspace-Rolle: was jedes erlaubt, und für welche Prozesse. */
			processRights: {
				hints: {
					view: "Prozesse in der Liste sehen, öffnen und live verfolgen. Wer in einem Prozess mitarbeitet, kann ihn auch ansehen.",
					takePart:
						"Fragen beantworten, Schaltflächen betätigen, Daten ändern, den Chat nutzen und Einträge für alle schließen.",
					start: "Neue Prozesse der gewählten Arten starten.",
					manage: "Prozesse stoppen, neu starten, archivieren, löschen und umbenennen. Mitarbeiten gehört nicht dazu.",
				},
				scope: {
					none: "Keine",
					selected: "Ausgewählte",
					limited: "Eingeschränkt",
					all: "Alle",
				},
				own: "Selbst gestartete Prozesse",
				ownHint: "Auch die Prozesse, die diese in ihrem Auftrag starten.",
				cell: {
					all: "Alle",
					own: "Eigene",
					ownPlus: "Eigene + {n}",
				},
			},
		},
	},
};
